import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitDialog = _resolveComponent("WaitDialog")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_m_btn = _resolveComponent("m-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WaitDialog, {
      isActive: $setup.loading,
      title: "Loading..."
    }, null, 8 /* PROPS */, ["isActive"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createCommentVNode(" Navigation Selectors "),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { class: "text-left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: $setup.selectedCompany,
                                  "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedCompany) = $event)),
                                    $setup.onCompanyChange
                                  ],
                                  items: $setup.companies,
                                  "item-title": $setup.companyDisplay,
                                  "item-value": item => item,
                                  label: "Company",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  loading: $setup.loadingCompanies
                                }, null, 8 /* PROPS */, ["modelValue", "items", "item-title", "item-value", "loading", "onUpdate:modelValue"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: $setup.selectedState,
                                  "onUpdate:modelValue": [
                                    _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedState) = $event)),
                                    $setup.onStateChange
                                  ],
                                  items: $setup.states,
                                  "item-title": "stateCode",
                                  "item-value": "stateCode",
                                  label: "State",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  disabled: !$setup.selectedCompany,
                                  loading: $setup.loadingStates
                                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled", "loading", "onUpdate:modelValue"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: $setup.selectedLob,
                                  "onUpdate:modelValue": [
                                    _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedLob) = $event)),
                                    $setup.onLobChange
                                  ],
                                  items: $setup.lobs,
                                  "item-title": "lobCode",
                                  "item-value": "lobCode",
                                  label: "Line of Business",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  disabled: !$setup.selectedState,
                                  loading: $setup.loadingLobs
                                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled", "loading", "onUpdate:modelValue"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  modelValue: $setup.selectedIssueCode,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedIssueCode) = $event)),
                                  items: $setup.issueCodes,
                                  "item-title": "description",
                                  "item-value": "code",
                                  label: "Issue Code",
                                  variant: "outlined",
                                  density: "comfortable",
                                  "hide-details": "",
                                  disabled: !$setup.selectedLob
                                }, null, 8 /* PROPS */, ["modelValue", "items", "disabled"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_col, {
                              cols: "12",
                              md: "3",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_m_btn, {
                                  color: "primary",
                                  "prepend-icon": "mdi-magnify",
                                  disabled: !$setup.canSearch,
                                  onClick: $setup.searchHovers
                                }, {
                                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                                    _createTextVNode(" Search Hovers ")
                                  ])),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "onClick"]),
                                _createVNode(_component_m_btn, {
                                  class: "ml-2",
                                  color: "secondary",
                                  "prepend-icon": "mdi-plus",
                                  disabled: !$setup.canSearch,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showAddDialog = true))
                                }, {
                                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                                    _createTextVNode(" Add Hover ")
                                  ])),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        _createCommentVNode(" Hovers Grid "),
        ($setup.hovers.length > 0 || $setup.userHovers.length > 0 || $setup.hasSearched)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tabs, {
                      modelValue: $setup.activeHoverTab,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.activeHoverTab) = $event)),
                      color: "primary",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tab, { value: "default" }, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createTextVNode("Default Hovers")
                          ])),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_tab, { value: "user" }, {
                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createTextVNode("User Hovers")
                          ])),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue"]),
                    _createVNode(_component_v_card, { class: "text-left" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tabs_window, {
                          modelValue: $setup.activeHoverTab,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.activeHoverTab) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tabs_window_item, { value: "default" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: $setup.hoverHeaders,
                                  items: $setup.hovers,
                                  loading: $setup.loading,
                                  density: "comfortable",
                                  class: "elevation-0",
                                  "no-data-text": "No hovers found",
                                  "items-per-page": "25",
                                  hover: ""
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(_component_v_toolbar, { flat: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_toolbar_title, null, {
                                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                                            _createTextVNode("Default Hovers")
                                          ])),
                                          _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_v_divider, {
                                          class: "mx-4",
                                          inset: "",
                                          vertical: ""
                                        }),
                                        _createVNode(_component_v_chip, { class: "mr-2" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.hovers.length) + " records", 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_m_btn, {
                                          color: "primary",
                                          "prepend-icon": "mdi-refresh",
                                          onClick: $setup.searchHovers
                                        }, {
                                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                                            _createTextVNode("Refresh")
                                          ])),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["headers", "items", "loading"])
                              ]),
                              _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_tabs_window_item, { value: "user" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_data_table, {
                                  headers: $setup.hoverHeaders,
                                  items: $setup.userHovers,
                                  loading: $setup.loading,
                                  density: "comfortable",
                                  class: "elevation-0",
                                  "no-data-text": "No user hovers found",
                                  "items-per-page": "25",
                                  hover: ""
                                }, {
                                  top: _withCtx(() => [
                                    _createVNode(_component_v_toolbar, { flat: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_toolbar_title, null, {
                                          default: _withCtx(() => _cache[29] || (_cache[29] = [
                                            _createTextVNode("User Hovers")
                                          ])),
                                          _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_v_divider, {
                                          class: "mx-4",
                                          inset: "",
                                          vertical: ""
                                        }),
                                        _createVNode(_component_v_chip, { class: "mr-2" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.userHovers.length) + " records", 1 /* TEXT */)
                                          ]),
                                          _: 1 /* STABLE */
                                        }),
                                        _createVNode(_component_m_btn, {
                                          color: "primary",
                                          "prepend-icon": "mdi-refresh",
                                          onClick: $setup.searchUserHoversForCurrentUser
                                        }, {
                                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                                            _createTextVNode("Refresh")
                                          ])),
                                          _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                      ]),
                                      _: 1 /* STABLE */
                                    })
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["headers", "items", "loading"])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Add Hover Dialog "),
        _createVNode(_component_v_dialog, {
          modelValue: $setup.showAddDialog,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.showAddDialog) = $event)),
          "max-width": "900",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("Add Hover Option")
                  ])),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.newHover.funcCode,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.newHover.funcCode) = $event)),
                              label: "Function Code *",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "100",
                              rules: [v => !!v || 'Required']
                            }, null, 8 /* PROPS */, ["modelValue", "rules"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.newHover.funcDesc,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.newHover.funcDesc) = $event)),
                              label: "Description",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "50"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.newHover.rclkUrl,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.newHover.rclkUrl) = $event)),
                              label: "URL",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "256"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.newHover.rclkReqst,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.newHover.rclkReqst) = $event)),
                              label: "Request Code",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "32",
                              loading: $setup.loadingReqCodeValidation,
                              error: $setup.reqCodeValid === false,
                              hint: $setup.reqCodeValid === false ? 'Invalid request code' : $setup.reqCodeValid === true ? 'Valid ✓' : '',
                              "persistent-hint": ""
                            }, null, 8 /* PROPS */, ["modelValue", "loading", "error", "hint"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $setup.newHover.polStat,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.newHover.polStat) = $event)),
                              items: $setup.policyStatuses,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Policy Status",
                              variant: "outlined",
                              density: "comfortable"
                            }, null, 8 /* PROPS */, ["modelValue", "items"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $setup.newHover.recStat,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.newHover.recStat) = $event)),
                              items: $setup.recordStatuses,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Record Status",
                              variant: "outlined",
                              density: "comfortable"
                            }, null, 8 /* PROPS */, ["modelValue", "items"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $setup.newHover.activityTypes,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.newHover.activityTypes) = $event)),
                              items: $setup.activityTypes,
                              "item-title": "text",
                              "item-value": "value",
                              label: "Activity Types *",
                              variant: "outlined",
                              density: "comfortable",
                              multiple: "",
                              chips: ""
                            }, null, 8 /* PROPS */, ["modelValue", "items"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: $setup.newHover.keyFields,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.newHover.keyFields) = $event)),
                              items: $setup.keyFields,
                              "item-title": "description",
                              "item-value": "code",
                              label: "Key Fields",
                              variant: "outlined",
                              density: "comfortable",
                              multiple: "",
                              chips: "",
                              loading: $setup.loadingKeyFields
                            }, null, 8 /* PROPS */, ["modelValue", "items", "loading"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: $setup.newHover.userName,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.newHover.userName) = $event)),
                              label: "User Name (blank=default)",
                              variant: "outlined",
                              density: "comfortable",
                              maxlength: "10"
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createCommentVNode(" Default Override Checkboxes "),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "12" }, {
                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createElementVNode("span", { class: "text-subtitle-2" }, "Default Overrides:", -1 /* HOISTED */)
                          ])),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: $setup.newHover.defaultLoc,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.newHover.defaultLoc) = $event)),
                              label: "Location = 99",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: $setup.newHover.defaultMco,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.newHover.defaultMco) = $event)),
                              label: "Master Co = 99",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: $setup.newHover.defaultPco,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.newHover.defaultPco) = $event)),
                              label: "Policy Co = 99",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: $setup.newHover.defaultState,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.newHover.defaultState) = $event)),
                              label: "State = US",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_col, { cols: "auto" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              modelValue: $setup.newHover.defaultLob,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.newHover.defaultLob) = $event)),
                              label: "LOB = All",
                              density: "comfortable",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"])
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_m_btn, {
                      onClick: _cache[21] || (_cache[21] = ($event: any) => ($setup.showAddDialog = false)),
                      text: "Cancel"
                    }),
                    _createVNode(_component_m_btn, {
                      color: "primary",
                      onClick: $setup.submitAddHover,
                      text: "Add Hover",
                      disabled: !$setup.newHover.funcCode || $setup.newHover.activityTypes.length === 0
                    }, null, 8 /* PROPS */, ["onClick", "disabled"])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _: 1 /* STABLE */
    })
  ], 64 /* STABLE_FRAGMENT */))
}